import { SecurityTab, Translation } from '@enums';
import i18n from '@translations';
import type { TabItem } from '@types';

export const getSecurityTabs = (): TabItem[] =>
  [
    {
      key: SecurityTab.SECURITY,
      name: i18n.t(`${Translation.Configuration}:buttons.waf.configuration`),
    },
  ] as const;
